import { App } from 'vue'
import { msalInstance, setMsalInitialized } from './auth/msalConfig'
import { ref } from 'vue'
import type { AccountInfo, InteractionStatus } from '@azure/msal-browser'

// Create reactive references for MSAL state
const accounts = ref<AccountInfo[]>([])
const inProgress = ref<InteractionStatus | false>(false)

// Export a function that takes the app instance
export default function(app: App) {
  // Initialize MSAL only once
  const initPromise = msalInstance.initialize().then(() => {
    setMsalInitialized(true)
    return msalInstance.handleRedirectPromise()
  }).then(response => {
    if (response) {
      console.log('Successful redirect response:', response)
      msalInstance.setActiveAccount(response.account)
    }
    // Update accounts after handling redirect
    accounts.value = msalInstance.getAllAccounts()
  }).catch(error => {
    console.error('Failed to initialize MSAL:', error)
  })

  // Add MSAL instance and state to Vue global properties
  app.config.globalProperties.$msal = {
    instance: msalInstance,
    accounts,
    inProgress,
    initialized: initPromise
  }

  // Return the initialization promise
  return initPromise
}
